export var ToastManagerActionKind;
(function (ToastManagerActionKind) {
    ToastManagerActionKind[ToastManagerActionKind["ADD"] = 0] = "ADD";
    ToastManagerActionKind[ToastManagerActionKind["REMOVE"] = 1] = "REMOVE";
    ToastManagerActionKind[ToastManagerActionKind["UPDATE"] = 2] = "UPDATE";
    ToastManagerActionKind[ToastManagerActionKind["CLEAR"] = 3] = "CLEAR";
})(ToastManagerActionKind || (ToastManagerActionKind = {}));
export function ToastManagerReducer(state = new Set(), action) {
    switch (action.type) {
        case ToastManagerActionKind.ADD: {
            if (action.payload && !state.has(action.payload)) {
                return new Set([...state, action.payload]);
            }
            return state;
        }
        case ToastManagerActionKind.REMOVE: {
            if (action.payload && state.has(action.payload)) {
                const nextState = new Set([...state]);
                nextState.delete(action.payload);
                return nextState;
            }
            return state;
        }
        case ToastManagerActionKind.UPDATE: {
            if (action.payload && state.has(action.payload)) {
                const currentState = [...state];
                const index = currentState.indexOf(action.payload);
                const nextState = new Set([
                    ...currentState.slice(0, index),
                    action.nextPayload,
                    ...currentState.slice(index + 1),
                ]);
                return nextState;
            }
            return state;
        }
        case ToastManagerActionKind.CLEAR: {
            return new Set();
        }
        default:
            return state;
    }
}
//# sourceMappingURL=ToastManagerReducer.js.map